import Header from './Header';

export { Header };
export default Header;
